import { ResourceLoader } from 'resource-loader';

export default new ResourceLoader();
